<script setup lang="ts">
  import { StatusStateMap } from '@/components/common/StatusIcon/statusIcon';
  import ElRouterLink from '@/components/common/ElRouterLink/ElRouterLink.vue';
  import { computed } from 'vue';
  import { ROUTE_NAME_CUSTOMER_HOME_VIEW } from '@/config/routeNames';
  import type { RouteRecordName } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import type { AsyncErrorMessageProps } from '@/components/common/AsyncLoader/asyncErrorMessage';
  import NotificationBox from '@/components/common/NotificationBox/NotificationBox.vue';
  import { components } from '@/cypaths';

  defineOptions({ name: 'AsyncErrorMessage' });

  const { showHomeLink = true, ...props } = defineProps<AsyncErrorMessageProps>();

  const { t } = useI18n();

  const homeRouteName = computed<RouteRecordName>(() => ROUTE_NAME_CUSTOMER_HOME_VIEW);

  const textList = computed<string[]>(() =>
    [props.text ||
      [
        t('appErrors.page.text1'),
        t('appErrors.page.text2'),
      ],
    ].flat());
</script>

<template>
  <div class="max-md:px-5">
    <NotificationBox
      :id="id"
      compact
      data-testid="async-error-message-box"
      :title="title || t('generic.anErrorHasOccurred')"
      :status="StatusStateMap.Error"
      class="md:container"
    >
      <div
        class="flex flex-col gap-4"
        data-testid="error-message-text"
        :data-cy="components.NOTIFICATION_BOX_CONTENT"
      >
        <template
          v-for="(textItem, idx) of textList"
          :key="idx"
        >
          <p>
            {{ textItem }}
          </p>
        </template>
      </div>
      <slot name="link">
        <ElRouterLink
          v-if="showHomeLink"
          :to="{name: homeRouteName}"
        >
          {{ t('generic.backHome') }}
        </ElRouterLink>
      </slot>
      <pre v-if="error">
      {{ error.reason }}
    </pre>
    </NotificationBox>
  </div>
</template>
